import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { PlatformApp } from "@taunggyi-plus/app-shell";
import { AuthProvider } from "@taunggyi-plus/auth";
import { getAppConfig, installPageZoomLock } from "@taunggyi-plus/config";
import { CustomerInformationDialog, HotelMore } from "@taunggyi-plus/customer-feature";
import "@taunggyi-plus/design-system/styles.css";
import { FinanceOverview } from "@taunggyi-plus/finance-feature";
import { HotelBookingInbox, HotelManagement } from "@taunggyi-plus/hotel-feature";
import { NotificationCenter } from "@taunggyi-plus/notifications";
import { PartnerApplication } from "@taunggyi-plus/onboarding-feature";

const authConfig = {
  appId: "hotel",
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
};

function HotelDashboard({ locale }: { readonly locale: "en" | "my" | "shn" | "zh" }) {
  return (
    <div className="role-dashboard role-dashboard--hotel">
      <PartnerApplication locale={locale} kind="hotel" />
      <HotelBookingInbox locale={locale} />
    </div>
  );
}

function HotelRooms({ locale }: { readonly locale: "en" | "my" | "shn" | "zh" }) {
  return (
    <div className="role-workspace role-workspace--hotel-rooms">
      <HotelManagement locale={locale} />
    </div>
  );
}

installPageZoomLock();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider config={authConfig}>
      <PlatformApp
        config={getAppConfig("hotel")}
        informationContent={(locale, id, onClose) => (
          <CustomerInformationDialog locale={locale} id={id} onClose={onClose} />
        )}
        navigationMode="owner"
        dashboardContent={(locale) => <HotelDashboard locale={locale} />}
        myServicesLabel="Rooms"
        myServicesPath="/rooms"
        myServicesContent={(locale) => <HotelRooms locale={locale} />}
        ordersContent={(locale) => <HotelBookingInbox locale={locale} showHeading={false} />}
        financeContent={<FinanceOverview role="hotel" />}
        moreContent={(locale, onLocaleChange, onOpenPreferences) => (
          <HotelMore
            locale={locale}
            onLocaleChange={onLocaleChange}
            onOpenPreferences={onOpenPreferences}
          />
        )}
        notificationContent={(locale) => (
          <NotificationCenter
            locale={locale}
            appId="hotel"
            embedded
            webPushPublicKey={import.meta.env.VITE_WEB_PUSH_PUBLIC_KEY}
          />
        )}
      />
    </AuthProvider>
  </StrictMode>,
);
